import { __decorate } from "tslib";
import Avatar from '@/components/Avatar.vue';
import BranchesSelect from "@/components/BranchesSelect.vue";
import Renderer from '@/components/Builder/Renderer.vue';
import CustomSwitch from "@/components/CustomSwitch.vue";
import DatePicker from '@/components/DatePicker.vue';
import MediaModal from '@/components/MediaModal.vue';
import Modal from "@/components/Modal.vue";
import PhoneField from "@/components/PhoneField.vue";
import Tags from "@/components/Tags.vue";
import TeamSelect from '@/components/TeamSelect.vue';
import ColorMixin from '@/mixins/color-mixin';
import ModalMixin from "@/mixins/modal-mixin";
import MergeCustomers from "@/Pages/People/MergeCustomers.vue";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapActions, mapGetters, mapState } from 'vuex';
import SourceFormModal from '../Company/Sources/SourceFormModal.vue';
let CustomerModalComponent = class CustomerModalComponent extends Mixins(ModalMixin, ColorMixin) {
    id;
    customer;
    areSourcesLoading;
    findItemsInStore;
    getMyCompany;
    getSources;
    removeCustomer;
    patchCustomer;
    createCustomer;
    tab = 'general';
    data = { source: {} };
    calendarOptions = {
        altFormat: "m/d/Y",
        maxDate: new Date(),
    };
    errors = null;
    get sources() {
        const data = this.findItemsInStore({}).data;
        return data.map(item => ({ value: item._id, text: item.label }));
    }
    get fields() {
        return this.getMyCompany('mine').fields;
    }
    close() {
        this.$root.$emit('bv::hide::modal', this.id);
    }
    deleteAction() {
        if (!this.data._id)
            return;
        this.removeCustomer(this.data._id).then(() => {
            this.$router.go(-1);
            this.$toasted.global.success({
                message: this.$t('Customer is archived')
            });
        });
    }
    clearImage() {
        delete this.data.avatar_id;
        delete this.data.avatar;
    }
    shown() {
        this.$root.$emit('bv::hide::tooltip');
        this.errors = {};
        this.data = JSON.parse(JSON.stringify(this.customer));
        this.data.source = this.data.source || {};
        if (!this.data.color) {
            this.$nextTick(() => this.$set(this.data, 'color', this.colors[Math.floor(Math.random() * this.colors.length)]));
        }
        this.getSources();
    }
    useImage(image) {
        this.data.avatar_id = image._id;
        this.data.avatar = image;
    }
    validation(field) {
        if (this.errors && this.errors[field])
            return false;
        else
            return null;
    }
    saveCustomer() {
        this.errors = null;
        let promise, successMessage;
        if (!this.data.avatar_id) {
            delete this.data.avatar_id;
            delete this.data.avatar;
        }
        if (this.data._id) {
            promise = this.patchCustomer([this.data._id, this.data, {}]);
            successMessage = this.$t('Customer is updated').toString();
        }
        else {
            promise = this.createCustomer(this.data).then(() => this.$root.$emit('32desk::customer::created'));
            successMessage = this.$t('Customer is registered').toString();
        }
        promise.then(() => {
            this.close();
            this.$toasted.global.success({
                message: successMessage
            });
            // this.data = {};
        }).catch(errors => {
            console.log(errors);
            this.errors = errors.errors;
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], CustomerModalComponent.prototype, "id", void 0);
__decorate([
    Prop({ type: Object })
], CustomerModalComponent.prototype, "customer", void 0);
CustomerModalComponent = __decorate([
    Component({
        name: 'customer-modal',
        components: {
            MergeCustomers,
            Tags,
            Modal,
            Avatar,
            Renderer,
            DatePicker,
            TeamSelect,
            PhoneField,
            MediaModal,
            CustomSwitch,
            BranchesSelect,
            Treeselect,
            SourceFormModal,
        },
        computed: {
            ...mapState('sources', { areSourcesLoading: 'isFindPending' }),
            ...mapGetters('sources', { findItemsInStore: 'find' }),
            ...mapGetters('my-company', { getMyCompany: 'get' }),
        },
        methods: {
            ...mapActions('customers', { removeCustomer: 'remove', patchCustomer: 'patch', createCustomer: 'create' }),
            ...mapActions('sources', { getSources: 'find' }),
        }
    })
], CustomerModalComponent);
export default CustomerModalComponent;
